module.exports = __webpack_public_path__ + "media/images/icons/text_blocks-05046365d36af8af86783b0823e5af37.gif";